<script lang="ts" setup>
import Permissions from '../../../../../shared/permissisons';
import PagesService from '#layers/cms/app/pages/cms/management/pages/_runtime/services/PagesService';
import { editorAPI } from '#layers/core/app/components/edito/editor/api';

const { $log } = useLogging();
const { $alert } = useAlerts();
const { $permissions } = usePermissions();

const show = ref(false);
const filemanager = ref(false);
const selectedPageId = ref<number>(null);
// const onPageSelect = async (id: number): Promise<void> =>
// {
//     selectedPageId.value = id;
// };

const onSave = async (): Promise<void> =>
{
    try
    {
        const symbols = [];
        let textAndTitle = '';
        let result: any = { parentId: selectedPageId.value };

        do
        {
            const response = await PagesService.fetchPage(result.parentId);

            if (symbols.length === 0)
                textAndTitle = response.result.name;

            symbols.unshift(response.result.symbol);
            result = response.result;
        } while (result.parentId != null);

        await editorAPI().activeEditor.setData({
            url: { value: `/${symbols.join('/')}`, meta: { original: `/${symbols.join('/')}/` } },
            text: textAndTitle,
            title: textAndTitle
        });
    }
    catch (ex: any)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });
    }
};

onMounted(async (): Promise<void> =>
{
    filemanager.value = await $permissions.all([Permissions.Storage.Access]);
});

defineExpose({
    init(editor: any)
    {
        editor.on('ExecCommand', function (e: any): void
        {
            if (e.command === 'mceLink')
            {
                setTimeout(() =>
                {
                    const iframe = document.querySelector('.tox-dialog__body-content');
                    const target = iframe.querySelector('.tox-form__controls-h-stack');
                    const toxBrowseUrl: any = target.querySelector('.tox-browse-url');

                    if (toxBrowseUrl)
                    {
                        if (filemanager.value)
                        {
                            toxBrowseUrl.title = $t('[[[Browse files]]]');
                        }
                        else
                        {
                            toxBrowseUrl.style.display = 'none';
                        }
                    }

                    const btn: any = document.createElement('button');

                    btn.title = $t('[[[Browse links]]]');
                    btn.type = 'button';
                    btn.tabIndex = -1;
                    btn['data-alloy-tabstop'] = true;
                    btn.classList.add('tox-button', 'tox-button--icon', 'tox-button--naked', 'tox-browse-url');
                    btn.onclick = function ()
                    {
                        selectedPageId.value = null;
                        show.value = true;
                    };

                    btn.innerHTML = `
                    <span class="tox-icon tox-tbtn__icon-wrap">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g stroke="none" stroke-width="1" fill-rule="evenodd">
                                <g transform="translate(3.000000, 3.000000)" fill-rule="nonzero">
                                    <path d="M3.19,9.345 C3.56860324,8.96738132 4.18139676,8.96738132 4.56,9.345 C4.7414263,9.52619538 4.84336998,9.7720877 4.84336998,10.0285 C4.84336998,10.2849123 4.7414263,10.5308046 4.56,10.712 L2.505,12.764 C2.14184108,13.1264311 1.93775923,13.6184301 1.93775923,14.1315 C1.93775923,14.6445699 2.14184108,15.1365689 2.505,15.499 C3.26220647,16.2542374 4.48779353,16.2542374 5.245,15.499 L10.039,10.712 C10.2204263,10.5308046 10.32237,10.2849123 10.32237,10.0285 C10.32237,9.7720877 10.2204263,9.52619538 10.039,9.345 C9.85726729,9.16376439 9.75512902,8.9176576 9.75512902,8.661 C9.75512902,8.4043424 9.85726729,8.15823561 10.039,7.977 C10.4176032,7.59938132 11.0303968,7.59938132 11.409,7.977 C11.9538916,8.5206667 12.2601117,9.25877256 12.2601117,10.0285 C12.2601117,10.7982274 11.9538916,11.5363333 11.409,12.08 L6.614,16.867 C5.09981452,18.3780248 2.64818548,18.3780248 1.134,16.867 C0.407682162,16.1421379 -0.000481544301,15.1581397 -0.000481544301,14.132 C-0.000481544301,13.1058603 0.407682162,12.1218621 1.134,11.397 L3.19,9.344 L3.19,9.345 Z M14.81,8.655 C14.4313968,9.03261868 13.8186032,9.03261868 13.44,8.655 C13.2585737,8.47380462 13.15663,8.2279123 13.15663,7.9715 C13.15663,7.7150877 13.2585737,7.46919538 13.44,7.288 L15.495,5.236 C15.8581589,4.87356893 16.0622408,4.38156986 16.0622408,3.8685 C16.0622408,3.35543014 15.8581589,2.86343107 15.495,2.501 C14.7377935,1.74576265 13.5122065,1.74576265 12.755,2.501 L7.962,7.288 C7.7805737,7.46919538 7.67863002,7.7150877 7.67863002,7.9715 C7.67863002,8.2279123 7.7805737,8.47380462 7.962,8.655 C8.14373271,8.83623561 8.24587098,9.0823424 8.24587098,9.339 C8.24587098,9.5956576 8.14373271,9.84176439 7.962,10.023 C7.58339676,10.4006187 6.97060324,10.4006187 6.592,10.023 C6.0471084,9.4793333 5.74088831,8.74122744 5.74088831,7.9715 C5.74088831,7.20177256 6.0471084,6.4636667 6.592,5.92 L11.387,1.133 C12.9011855,-0.378024781 15.3528145,-0.378024781 16.867,1.133 C17.5933178,1.85786214 18.0014815,2.84186028 18.0014815,3.868 C18.0014815,4.89413972 17.5933178,5.87813786 16.867,6.603 L14.81,8.656 L14.81,8.655 Z"></path>
                                </g>
                            </g>
                        </svg>
                    </span>`;

                    target.appendChild(btn);
                },
                100);
            }
        });
    }
});
</script>

<template>
    <IdeoModal
        v-model="show"
        :title="$t('[[[Struktura serwisu]]]')"
        modal-class="url-modal"
        backdrop-class="url-backdrop"
        @ok="onSave"
    >
        <!-- <PagesList :preview="true" :selected="selectedPageId" @on-select="onPageSelect" /> -->
        TODO
    </IdeoModal>
</template>

<style lang="scss">
.url {
    &-modal {
        z-index: 10400 !important;
    }
    &-backdrop {
        z-index: 10399 !important;
    }
}
</style>
